import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, DetachedRouteHandle, RouteReuseStrategy } from '@angular/router';

/**
 * Extends Angular's default route reuse behavior to prevent component reuse
 * when navigating between construction projects (different :id param).
 * This ensures child components always render fresh data after a project switch.
 */
@Injectable()
export class ProjectAwareRouteReuseStrategy implements RouteReuseStrategy {
  public shouldDetach(_route: ActivatedRouteSnapshot): boolean {
    return false;
  }

  public store(_route: ActivatedRouteSnapshot, _detachedTree: DetachedRouteHandle): void {}

  public shouldAttach(_route: ActivatedRouteSnapshot): boolean {
    return false;
  }

  public retrieve(_route: ActivatedRouteSnapshot): DetachedRouteHandle | null {
    return null;
  }

  public shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    if (future.routeConfig !== curr.routeConfig) return false;

    const futureProjectId = this.getConstructionProjectId(future);
    const currProjectId = this.getConstructionProjectId(curr);

    if (futureProjectId !== null && currProjectId !== null && futureProjectId !== currProjectId) {
      return false;
    }

    return this.paramsEqual(future.params, curr.params);
  }

  private getConstructionProjectId(route: ActivatedRouteSnapshot): string | null {
    let r: ActivatedRouteSnapshot | null = route;
    while (r) {
      if (r.params['id'] && r.parent?.url.some((s) => s.path === 'projects')) {
        return r.params['id'];
      }
      r = r.parent;
    }

    return null;
  }

  private paramsEqual(a: Record<string, string>, b: Record<string, string>): boolean {
    const keysA = Object.keys(a);
    if (keysA.length !== Object.keys(b).length) return false;

    return keysA.every((key) => a[key] === b[key]);
  }
}
